import { WaveEventItem, WaveEventPreview } from '@anm/api/modules/waveEvents';
import getDateMonthYear from '@anm/helpers/date/getDateMonthYear';
import round2Chars from '@anm/helpers/parsers/round2Chars';

export const getIsFutureDate = (dateStr: string) => {
  const [date, month, year] = getDateMonthYear();

  const eventDate = dateStr.replace(/-/g, '');
  const dateNow = year + round2Chars(month + 1) + round2Chars(date);

  return eventDate >= dateNow;
};

const isSquareFormat = ({ size }: WaveEventPreview) =>
  size.height === size.width;

export const getCalendarData = (data: WaveEventItem[]) => {
  const dataWithSquarePreview = data.filter(
    item => item.preview && isSquareFormat(item.preview[0])
  );

  const indexToSlice = dataWithSquarePreview.findIndex(event =>
    getIsFutureDate(event.date)
  );

  return dataWithSquarePreview.slice(indexToSlice, indexToSlice + 10);
};
